<template>
  <!-- eslint-disable max-len -->
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.8655 3.15789L12.9076 0.175439C12.8179 0 12.6387 0 12.549 0C12.4594 0 12.3697 0.0877193 12.2801 0.175439L0.627451 12.0175C0.537815 12.1053 0.448179 12.193 0.448179 12.3684L0.0896358 15.7018C0.0896358 15.9649 0.268908 16.2281 0.537815 16.3158H0.627451L3.94398 15.9649C4.03361 15.9649 4.12325 15.8772 4.21288 15.7895L15.8655 3.85965C16.0448 3.68421 16.0448 3.33333 15.8655 3.15789ZM1.07563 15.0877L1.34454 13.1579L3.04762 14.9123L1.07563 15.0877ZM4.03361 14.4737L1.88235 12.2807L11.1148 2.7193L13.2661 4.91228L4.03361 14.4737ZM14.0728 4.21053L11.9216 2.01754L12.6387 1.31579L14.7899 3.50877L14.0728 4.21053ZM0 20H14.8796V18.7719H0V20Z"
  />
</template>
